import { useInterval } from '@timelyapp/react';
import classNames from 'classnames';
import { MINUTE_HEIGHT_PX } from 'constants/hour';
import type { DateTime } from 'luxon';
import React from 'react';
import { getCurrentMomentOnDay } from 'utils/date-helper';
import { convertTimestampToPx } from 'utils/event';
import styles from './CurrentTimeIndicator.module.scss';

interface Props {
  fromHour: DateTime<true>;
  showDot: boolean;
  date: string;
  leftPx: number;
  pixelsPerMinute: number;
  offsetTopPx: number;
}

const CurrentTimeIndicator = ({
  date,
  fromHour,
  pixelsPerMinute,
  showDot,
  leftPx,
  offsetTopPx,
}: Props) => {
  const relativeToday = getCurrentMomentOnDay(date);
  const topPx = convertTimestampToPx(relativeToday, fromHour.toISO(), offsetTopPx, {
    pixelsPerMinute,
  });

  const currentTimeStyle = {
    top: topPx,
    left: leftPx,
    width: '100%',
  };

  const containerClass = classNames(styles.container, { [styles.withDot]: showDot });

  // Re-render this every minute to keep in sync with real time.
  useInterval(60000);

  return (
    <div className={containerClass} style={currentTimeStyle}>
      <div />
    </div>
  );
};

CurrentTimeIndicator.defaultProps = {
  leftPx: null,
  pixelsPerMinute: MINUTE_HEIGHT_PX,
  offsetTopPx: 0,
  showDot: true,
};

export default CurrentTimeIndicator;
